import React from "react";
import newnftsgif from "../../assets/nfts-gif-new.mp4";
import tabletimg from "../../assets/tablet.png";
const About = () => {
  return (
    <div
      className="section-container flex flex-none flex-col-reverse items-center lg:flex-row justify-around"
      id="about"
    >
      <div className="w-full px-5 lg:w-1/2 relative flex items-center justify-center">
        <img
          src={tabletimg}
          alt="background tablet"
          style={{ width: "34rem" }}
          className="lg:absolute z-10"
        ></img>
        <video
          src={newnftsgif}
          type="video/mp4"
          autoPlay
          loop
          alt="nfts gif"
          className="absolute w-[10rem] mobile:w-[15rem] mt-10 z-20"
        ></video>
      </div>
      <div className="w-10/12 px-5 lg:w-1/2 lg:pl-20 lg:pr-28 flex flex-col justify-center">
        <h3 className="section-title">About Us</h3>
        <p className="text-justify text-base lg:text-xl">
          CryptoGods: Anubis is a collection of 10000 randomly generated NFTs
          which welcome the Egyptian God of the Dead into the metaverse.
          CryptoGods: Anubis holders will be a part of the global community
          which gets access to exclusive events, special giveaways and many
          bonuses along the journey.
        </p>
      </div>
    </div>
  );
};
export default About;
